/*
  replace redux-bundler route params variables with supplied args

  example usage: urlFormatter({ url: /boards/:boardId/salesboard, boardId: '00000000' })
  output: /boards/00000000/salesboard
*/
export default ({ url, ...args }) => {
  let newURL = url;
  if (typeof newURL !== 'string') return url;

  Object.entries(args).forEach(([k, v]) => {
    if (typeof k === 'string' && k && typeof v === 'string' && v)
      newURL = newURL.replace(`:${k}`, v);
  });

  return newURL;
};
